import SlideShowGallery_SlideShowGallerySloopyComponent from '../components/NativeGalleries/SlideShowGallery/viewer/skinComps/SlideShowGallerySloopy/SlideShowGallerySloopy.skin';
import SlideShowGallery_SlideShowGallerySloopyController from '../components/NativeGalleries/SlideShowGallery/viewer/SlideShowGallery.controller';


const SlideShowGallery_SlideShowGallerySloopy = {
  component: SlideShowGallery_SlideShowGallerySloopyComponent,
  controller: SlideShowGallery_SlideShowGallerySloopyController
};


export const components = {
  ['SlideShowGallery_SlideShowGallerySloopy']: SlideShowGallery_SlideShowGallerySloopy
};

